import { gql } from '@apollo/client';
import { CRM_CAMPAIGN_FIELDS } from './queries';

export const CREATE_CRM_CAMPAIGN = gql`
    mutation CreateCrmCampaign($input: CreateCrmCampaignInput!) {
        createCrmCampaign(input: $input) {
            ${CRM_CAMPAIGN_FIELDS}
        }
    }
`;

export const UPDATE_CRM_CAMPAIGN = gql`
    mutation UpdateCrmCampaign($input: UpdateCrmCampaignInput!) {
        updateCrmCampaign(input: $input) {
            ${CRM_CAMPAIGN_FIELDS}
        }
    }
`;

export const DELETE_CRM_CAMPAIGN = gql`
    mutation DeleteCrmCampaign($id: String!) {
        deleteCrmCampaign(id: $id) {
            _id
            name
        }
    }
`;

export const SCHEDULE_CRM_CAMPAIGN = gql`
    mutation ScheduleCrmCampaign($input: ScheduleCrmCampaignInput!) {
        scheduleCrmCampaign(input: $input) {
            ${CRM_CAMPAIGN_FIELDS}
        }
    }
`;

export const SEND_CRM_CAMPAIGN_NOW = gql`
    mutation SendCrmCampaignNow($campaignId: String!) {
        sendCrmCampaignNow(campaignId: $campaignId) {
            ${CRM_CAMPAIGN_FIELDS}
        }
    }
`;

export const SEND_CRM_TEST_EMAIL = gql`
    mutation SendCrmTestEmail($input: SendCrmTestEmailInput!) {
        sendCrmTestEmail(input: $input) {
            crmMessageId
            status
            reason
        }
    }
`;

export const ADD_CRM_CAMPAIGN_RECIPIENT = gql`
    mutation AddCrmCampaignRecipient($input: AddCrmCampaignRecipientInput!) {
        addCrmCampaignRecipient(input: $input) {
            email
            status
            outcomeReason
            sentAt
        }
    }
`;

export const SEND_CRM_CAMPAIGN_TO_TARGET = gql`
    mutation SendCrmCampaignToTarget($input: SendCrmCampaignTargetInput!) {
        sendCrmCampaignToTarget(input: $input) {
            requested
            sent
            skipped
            alreadyReceived
            failed
            blockedContactId
        }
    }
`;
